// Static golden ring on a favorited friend's avatar, shared by every surface
// that marks favorites (Facepile, UserRow, FriendsStrip, festival-mode rows,
// TicketHolderPicker) so the treatment stays identical.
export const favoriteRingClass = 'border-2 border-amber-400'
